import { Component, OnInit } from "@angular/core";
import { OriginService } from '@wgu-edu/oauth2';
import { SafeLogger } from "src/app/utils/safe-logger";

/**
 * This component makes it so that the initial person request (from app-startup.service)
 * that fails causes a refresh as we're redirected back to origin.  That makes it so upon
 * reload, the person request succeeds.
 *
 * The extraction of the cb parameters happens elsewhere because
 * this component is hit too late to process the parameters here.
 */
@Component({
    selector: 'app-auth-cb',
    templateUrl: './cb.component.html',
    styleUrls: ['./cb.component.css']
})
export class CallBackComponent implements OnInit{
  constructor(
    private originService: OriginService
  ) {}

  ngOnInit(){
    /*
     * There is a rare case of receiving an authentication responses without a callback to handle it.  When
     * that happens, this page may come up and stay until the token is renewed/refreshed.  This timer will make
     * sure we don't stay on this page too long.
     */
    setTimeout(() => {
      SafeLogger.log("Restore Origin");
      this.originService.restoreOrigin('/');
    }, 2500);
  }
}
